<template>
    <div id="Kassensystem">
        <KassensystemAuswahl v-if="auswahl" @openKassensystemMain="this.onOpenKassensystemMain"/>
        <KassensystemMain v-if="main" :kassenProjekt="this.kassenProjekt" @openKassensystemAuswahl="this.onOpenKassensystemAuswahl()"/>
    </div>   
    <!--<router-link :to="`/mehr/`+this.$route.params.id"><button id="homeButton" class="mapButton"><img src="@/assets/Icons/HomeButton.svg"></button></router-link>-->
</template>

<script>
import KassensystemMain from '@/components/Kassensystem/KassensystemMain.vue'
import KassensystemAuswahl from '@/components/Kassensystem/KassensystemAuswahl.vue';

export default {
    name: 'Kassensystem',
    components: {
        KassensystemMain,
        KassensystemAuswahl
    },
    data() {
        return{
            auswahl: true,
            main: false,
            kassenProjekt: {}
        }
    },
    methods:{
        onOpenKassensystemMain(projekt){
            this.kassenProjekt = projekt;
            this.auswahl = false;
            this.main = true;
        },
        onOpenKassensystemAuswahl(){
            this.kassenProjekt = undefined;
            this.auswahl = true;
            this.main = false;
        }
    },
    created(){

    },
    setup(){
        const emits = ['openKassensystemMain', 'openKassensystemAuswahl'];
        return { emits };
    }
}
</script>

<style lang="scss" scoped>
#Kassensystem{
    overflow-y: hidden;

}
</style>